import styled from "styled-components";

const ContentLeft = styled.div`
  width: 90%;
  padding:2em;
  text-align: left;
  color: black;
  padding-top:0px;
  text-decoration: none;
  a {
    text-decoration: none;
  }
  a:visited {
    color: #3333cc;
  }
  a:hover, a:visited:hover {
    color: #cc33cc;
  }
`;

const Audio = () => {
  return(
    <ContentLeft>
      Here is some music I've worked on:<br/>
      <a href="https://animalteeth.bandcamp.com">Animal Teeth</a><br/>
      <a href="https://booter.bandcamp.com">Booter</a><br/>
      <a href="https://huthut.bandcamp.com">Hut Hut</a><br/>
      <a href="https://iansucks.bandcamp.com">iansucks</a><br/>
    </ContentLeft>
  )
};
  
export default Audio;